import style from './style.module.sass'
import { Button, Checkbox, createTheme, ThemeProvider } from '@material-ui/core'
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useActions } from '../../../utils/action-helper'
import { dashboardSetFolderSelected, dashboardSetOpenedFolders } from '../../../actions'
import { ExpandMore, ChevronRight, } from '@material-ui/icons'
import { contrastCheckBox, deepCopy } from '../../../utils'
import { useTheme } from '@material-ui/styles'
import config from '../../../config'

export default function FolderSelectionTable ({ panel }) {
  const { t } = useTranslation()
  const { theme: { bgColors, colors } } = useTheme()
  const [selectAll, setSelectAll] = useState(false)
  const customTheme = contrastCheckBox(colors, createTheme)
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT

  const folderList = useSelector(state => state.dashboardData.folderList[panel])
  const folderSelected = useSelector(state => state.dashboardData.folderSelected[panel])
  const openedFolders = useSelector(state => state.dashboardData.openedFolders[panel])

  const recursiveRenderRows = (rows, deep) => {
    let res = []
    for (const row of rows) {
      res.push({ ...row, deep })
      if (openedFolders.indexOf(row.id) > -1 && row.child?.length) {
        res = [...res, ...recursiveRenderRows(row.child, deep + 1)]
      }
    }
    return res
  }

  const folderRows = useMemo(() => recursiveRenderRows(folderList, 0), [folderList, openedFolders])

  const { aDashboardSetFolderSelected, aDashboardSetOpenedFolders } = useActions({
    aDashboardSetOpenedFolders: dashboardSetOpenedFolders,
    aDashboardSetFolderSelected: dashboardSetFolderSelected
  })

  function onFolderChange (id) {
    const idPosition = folderSelected.indexOf(id)
    if (idPosition === -1) {
      aDashboardSetFolderSelected(panel, [...folderSelected, id])
    } else {
      aDashboardSetFolderSelected(panel, folderSelected.filter(v => v !== id))
    }
  }

  //useEffect(() => {
  //    setSelectAll(folderRows.every(v => folderList.indexOf(v.id) > -1));
  //}, [folderList, folderRows])

  function onOpenFolder (id) {
    const tmpOpenedFolders = deepCopy(openedFolders)
    const index = tmpOpenedFolders.indexOf(id)
    if (index > -1) {
      delete tmpOpenedFolders[index]
    } else {
      tmpOpenedFolders.push(id)
    }
    aDashboardSetOpenedFolders(panel, tmpOpenedFolders)
  }

  const onSelectAll = () => {
    let newList = []

    if (!selectAll) {
      for (let addId of folderRows) {
        newList.push(addId.id)
      }
      newList.push(0)
    } else {
      newList = []
    }

    aDashboardSetFolderSelected(panel, newList)
    setSelectAll(!selectAll)
  }

  const DrawRow = ({ folderId, folderName, shift, checked, opened, addButton }) => {
    return (
      <tr>
        <td className={'p-0 m-0'} width={50} style={{ backgroundColor: bgColors.bgPrimary200 }}>
          <div className="d-flex align-items-center justify-content-center">
            <ThemeProvider theme={customTheme}>
              <Checkbox checked={checked} onChange={() => onFolderChange(folderId)} inputProps={{ 'aria-label': t('Select folder') }}
                />
            </ThemeProvider>
          </div>
        </td>
        <td>
          <div className="m-0 mr-auto" style={{ paddingLeft: `${shift}px` }}>
            {addButton ?
              <Button aria-label={opened ? t('Collapse folder') : t('Expand folder')} className={'pointer-event p-0 m-0'} style={{ color: colors.colorIcons }} onClick={() => onOpenFolder(folderId)}>
                {opened ? <ExpandMore/> : <ChevronRight/>}
              </Button>
              :
              <span style={{ marginLeft: '58px' }}>&nbsp;</span>
            }
            <span style={{ color: colors.colorText }} onClick={() => onOpenFolder(folderId)}>{folderName}</span>
          </div>
        </td>
      </tr>
    )
  }

  return (
    <div className={'p-0 m-0'}
         style={{ backgroundColor: bgColors.bgPrimary0, maxHeight: '300px', minHeight: '300px', overflowY: 'scroll' }}>
      <table border={'1px solid #000'} className={`${style.table}`} style={{ backgroundColor: isContrast ? bgColors.bgPrimary400 : bgColors.bgPrimary0 }}>
        <thead>
        <tr style={{ backgroundColor: isContrast ? bgColors.bgPrimary500 : bgColors.bgPrimary200 }}>
          <th>
            <div>
              {folderRows?.length ?
                  <ThemeProvider theme={customTheme}>
                    <Checkbox checked={selectAll} onChange={onSelectAll} id="name-selects" inputProps={{ 'aria-label': t('Select all folders') }} />
                  </ThemeProvider> :
                <div/>}
            </div>
          </th>
          <th>
            <h6 className={`m-0 mr-auto`} style={{ color: colors.colorText }}>{t('Folders')}</h6>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td className={'p-0 m-0'} width={50} style={{ backgroundColor: bgColors.bgPrimary200 }}>
            <div className="d-flex align-items-center justify-content-center">
              <ThemeProvider theme={customTheme}>
              <Checkbox checked={folderSelected.indexOf(0) > -1} onChange={() => onFolderChange(0)} inputProps={{'aria-label': t('Select root folder')}} />
              </ThemeProvider>
            </div>
          </td>
          <td>
            <div className="m-0 mr-auto" style={{ paddingLeft: `0px`, color: colors.colorText }}>
              <span style={{ marginLeft: '20px' }}>&nbsp;</span>
              <span onClick={() => onOpenFolder(0)}>{t('root_folder')}</span>
            </div>
          </td>
        </tr>
        {folderRows.map(v =>
          <DrawRow
            addButton={v.child?.length}
            key={v.id}
            folderId={v.id}
            folderName={v.folder_name}
            shift={v.deep * 20}
            checked={folderSelected.indexOf(v.id) > -1}
            opened={openedFolders.indexOf(v.id) > -1}
          />
        )}
        </tbody>
      </table>
    </div>
  )
}